export const FETCH_SHOP_BY_BRAND_REQUEST = 'FETCH_SHOP_BY_BRAND_REQUEST';
export const FETCH_SHOP_BY_BRAND_SUCCESS = 'FETCH_SHOP_BY_BRAND_SUCCESS';
export const FETCH_SHOP_BY_BRAND_FAILURE = 'FETCH_SHOP_BY_BRAND_FAILURE';
